// Native push registration (no-ops on web). Unified FCM tokens via @capacitor-firebase/messaging.
import { Capacitor } from "@capacitor/core";
import api from "./api";

export async function initPush() {
  if (!Capacitor.isNativePlatform()) return; // web build → skip
  try {
    const { FirebaseMessaging } = await import("@capacitor-firebase/messaging");

    let perm = await FirebaseMessaging.checkPermissions();
    if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
      perm = await FirebaseMessaging.requestPermissions();
    }
    if (perm.receive !== "granted") return;

    const platform = Capacitor.getPlatform();
    const { token } = await FirebaseMessaging.getToken();
    if (token) {
      try { await api.registerPush(token, platform); } catch (e) { /* retry next launch */ }
    }

    // Token rotation → keep backend in sync.
    await FirebaseMessaging.addListener("tokenReceived", async (event) => {
      if (event?.token) {
        try { await api.registerPush(event.token, platform); } catch (e) { /* ignore */ }
      }
    });

    // Foreground message (OS may suppress banner while app is active).
    await FirebaseMessaging.addListener("notificationReceived", (event) => {
      console.log("Push received", event?.notification);
    });

    // Tapping a notification deep-links into the matching screen.
    await FirebaseMessaging.addListener("notificationActionPerformed", (event) => {
      const link = event?.notification?.data?.link;
      if (link) window.dispatchEvent(new CustomEvent("wyvn:navigate", { detail: link }));
    });
  } catch (e) {
    console.warn("Push init skipped", e);
  }
}
